import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import UserAllAssignableModel from "../../models/user-all-assignable";

export default class UserAllAssignableRepository extends BaseRepository {
  static modelClass = UserAllAssignableModel;
  modelName = "user-all-assignable";
}
